import { useEffect, useState } from "react";
import {
	Button,
	Card,
	Grid,
	Typography,
	CardContent,
	CardActions,
	Icon,
	FormHelperText,
	IconButton
} from "@material-ui/core";
import { ImageFit } from "@ploy-ui/core";
import { useTenantImage } from "@ploy-ui/tenants";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { FormattedMessage } from "react-intl";
import { useParsedQuery } from "@ploy-lib/routing";

const useStyles = makeStyles(
	(theme: Theme) => ({
		root: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			flexDirection: "column"
		},
		logoWrapper: {
			paddingTop: theme.spacing(2),
			paddingBottom: theme.spacing(2)
		},
		logo: {
			width: "100%",
			height: 64
		},
		cardAction: {
			justifyContent: "center"
		},
		page: {
			height: "100vh",
			padding: 20
		},
		container: {
			height: "100%"
		}
	}),
	{ name: "DployFirstAccessPage" }
);

const setCookie = (cname: string, cvalue: string, exdays: number) => {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};
const buttonClick = (setButtonClicked: (clicked: boolean) => any) => {
	setCookie("checkCookie", "true", 365);
	setButtonClicked(true);
	window.close();
};

/**
 * Page to access form-web/partner-web as a first party.
 * This is needed before we can ask for storageAccess in Safari.
 * @param props
 */
export const FirstPartyAccessPage = () => {
	const classes = useStyles();

	const { imediateReturn = false } = useParsedQuery<{
		imediateReturn?: boolean;
	}>();
	const [buttonClicked, setButtonCliked] = useState(false);
	const [showHelperText, setShowHelperText] = useState(false);

	const logo = useTenantImage("form_web_logo");

	useEffect(() => {
		if (imediateReturn) {
			setCookie("checkCookie", "true", 365);
			window.close();
		}
	}, [imediateReturn]);

	return (
		<div className={classes.page}>
			<Grid
				container
				spacing={4}
				alignItems="center"
				justifyContent="center"
				className={classes.container}
			>
				<Grid item xs={12} md={8} lg={6}>
					<Card>
						<CardContent>
							<div className={clsx(classes.logoWrapper, classes.root)}>
								{logo ? (
									<ImageFit
										className={classes.logo}
										src={logo}
										alt="logo"
										fit="contain"
									/>
								) : (
									<Icon
										className="fa fa-cookie-bite"
										style={{ fontSize: 30 }}
									/>
								)}
							</div>
							<Grid container spacing={2}>
								<Grid item xs={11}>
									<Typography>
										<FormattedMessage
											id="storageAccess.card.content.infotext"
											defaultMessage="For å kunne bruke søknadskjemaet i din nettleser må du trykke på knappen under.
															Etter du har trykket, vil dette vinduet lukke seg og du vil bli sendt tilbake til søknadsskjemaet.
															Der vil vi be deg bekrefte tilgangen."
										/>
									</Typography>
								</Grid>
								<Grid item xs={1}>
									<IconButton
										onClick={() => setShowHelperText(!showHelperText)}
									>
										<Icon
											className={
												showHelperText
													? "fas fa-question-circle"
													: "far fa-question-circle"
											}
										/>
									</IconButton>
								</Grid>
								{showHelperText && (
									<Grid item xs={12}>
										<FormHelperText>
											<Typography>
												<FormattedMessage
													id="storageAccess.card.content.infotextHelper"
													defaultMessage="Din nettleser tillater ikke at tredjeparter lagrer informasjonskapsler (cookies)
													dersom brukeren ikke har besøkt og interagert med
													tredjepartsdomenet. Dermed må du som bruker nå interagere med vårt
													nettsted ved å trykke på knappen under. slik at vi kan be om tilgang fra
													din nettleser."
												/>
											</Typography>
										</FormHelperText>
									</Grid>
								)}
							</Grid>
						</CardContent>
						<CardActions classes={{ root: classes.cardAction }}>
							<Button
								variant={"contained"}
								color="secondary"
								onClick={() => buttonClick(setButtonCliked)}
							>
								<FormattedMessage
									id="storageAccess.card.content.allowAccessButton"
									defaultMessage="Sett tilgang"
								/>
							</Button>
						</CardActions>

						{buttonClicked && (
							<CardContent>
								<Typography>
									<FormattedMessage
										id="storageAccess.card.content.accessFailedText"
										defaultMessage="Du kan nå lukke dette vinduet"
									/>
								</Typography>
							</CardContent>
						)}
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

FirstPartyAccessPage.displayName = "DployFirstPartyAccessPage";
